import { isFunction } from 'lodash'

const productDetailNavMixin = {
  data () {
    return {
      mb: this.$store.getters['session/getMb'],
      adltCtfcYn: this.$store.getters['session/getAdltCtfcYn'],
      adltCtfcCd: this.$store.getters['session/getAdltCtfcCd'],
    }
  },
  methods: {
    getDlvChip () {
      const path = this.$route.path
      if (path.includes('/quickOrder')) {
        return '05'
      }
      if (path.includes('/pickupOrder')) {
        return '02'
      }
      if (path.includes('/bulkOrder')) {
        return '04'
      }
      return null
    },
    detailAdultCert (obj) { // 상품설명 클릭시 성인인증 필요한 상품, 판매예정 상품 처리
      if (obj.buyLmtAgeCd === '03' && this.adltCtfcYn !== 'Y') {
        console.log('성인인증필요')
        this.adultCert(obj)
      } else if (obj.wrhParmDt && obj.sleStsCd === '02') { // 판매예정인경우
        this.confirm(this.$t('PD.NOTIFY_PD_CONFIRM')).then(() => {
          // this.sendFeedback(obj)
          const query = { pdNo: obj.pdNo, recmYn: this.recmYn ? 'Y' : 'N' }
          const dlvChip = this.getDlvChip()
          if (dlvChip) {
            query.dlvChip = dlvChip
          }
          this.$router.push({ path: '/pd/pdr/SCR_PDR_0001', query })
        })
      } else {
        // this.sendFeedback(obj)
        const query = { pdNo: obj.pdNo, recmYn: this.recmYn ? 'Y' : 'N' }
        const dlvChip = this.getDlvChip()
        if (dlvChip) {
          query.dlvChip = dlvChip
        }
        if (this.$route.path === '/pd/pdr/SCR_PDR_0001' && this.$route.query.pdNo === obj.pdNo) {
          window.location.reload()
        } else {
          this.$router.push({ path: '/pd/pdr/SCR_PDR_0001', query })
        }
      }
    },
    async adultCert (obj) {
      const dlvChip = this.getDlvChip()
      let returnUrlPath = `/pd/pdr/SCR_PDR_0001?pdNo=${obj.pdNo}&recmYn=${this.recmYn ? 'Y' : 'N'}`
      if (dlvChip) {
        returnUrlPath += `&dlvChip=${dlvChip}`
      }

      console.log('로그인체크', this.mb.mbMngNo)
      if (this.mb.mbMngNo === undefined) { // 로그인 정보가 없으면 로그인페이지로 이동
        const nowPath = this.$route.fullPath
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: returnUrlPath, adltAuth: 'Y', adltReturnUrl: nowPath } })
        return
      }

      if (this.mb.mbMngNo !== undefined && this.adltCtfcCd === '02') { // 로그인되어 있고 성인인증 미인증
        if (await this.confirm(this.$t('PD.CERTIFY_ADULT'), { center: true, dangerouslyUseHTMLString: true })) {
          this.$router.push({
            name: 'mb-mbc-SCR_MBC_0110A_01',
            path: '/mb/mbc/SCR_MBC_0110A_01',
            params: { redirectUrl: returnUrlPath }, // 인증완료 후 리턴할 상품화면
          })
        }
      } else if (this.mb.mbMngNo !== undefined && this.adltCtfcCd === '03') { // 로그인 되어 있고 성인인증 인증만료
        if (await this.confirm(this.$t('PD.CERTIFY_ADULT_EXPIRED'), { center: true, dangerouslyUseHTMLString: true })) {
          this.$router.push({
            name: 'mb-mbc-SCR_MBC_0110A_01',
            path: '/mb/mbc/SCR_MBC_0110A_01',
            params: { redirectUrl: returnUrlPath }, // 인증완료 후 리턴할 상품화면
          })
        }
      } else { // 로그인되어 있고 성인인증도 되어있으면 상품상세로 이동
        // this.sendFeedback(obj)
        const query = { pdNo: obj.pdNo, recmYn: this.recmYn ? 'Y' : 'N' }
        if (dlvChip) {
          query.dlvChip = dlvChip
        }
        this.$router.push({ path: '/pd/pdr/SCR_PDR_0001', query })
      }
    },
    async confirm (message, opt) {
      let isOk = false

      await this.$confirm(message, '', {
        confirmButtonText: opt?.yes || '확인',
        cancelButtonText: opt?.no || '취소',
        center: opt?.center || false,
        dangerouslyUseHTMLString: true,
        customClass: opt?.customClass || '',
      }).then(() => { // 확인 버튼 클릭시
        if (isFunction(opt?.okCallback)) {
          opt.okCallback.apply(this, opt?.okParam)
        }
        isOk = true
      }).catch(() => { // 취소 버튼 또는 알림창 밖 클릭시
        if (isFunction(opt?.cancelCallback)) {
          opt.cancelCallback.apply(this, opt?.cancelParam)
        }
      })

      return isOk
    },
  },
}

export { productDetailNavMixin }
